import React from 'react';
import { NucleusCore } from '@builtbypixel/nucleus'
import config from './config'
import routes from './routes'
import links from './links'

function App() {
  return (
    <NucleusCore config={config} routes={routes} links={links} />
  );
}

export default App;
